import React from 'react';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import {openSubmitCommentModal} from '../reducers/modals';
import {setHomeworkCorrected} from '../reducers/assistant';
import MenuBarAssistantComponent from '../components/menu-bar-assistant/menu-bar-assistant.jsx';
import {setAssistantWorkInfo} from '../lib/assistant-work-info.js';
import {isLastHomework, getHomeworkInfo, goAeadToNextHomework} from '../lib/assistant-work-api.js';
import {setHomeworkStatus} from '../lib/service-assistant.js';
import {getParameterByName} from '../utils/tools';

class MenuBarAssistant extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClickAnswer',
            'handleClickNextItem',
            'setListEmptyState',
            'setTipsState',
            'handleClickOpenSubmitCommentModal',
            'handleTimeoutHideTips'
        ]);
        const isAnswer = getParameterByName('isAnswer');
        const className = getParameterByName('className');
        const courseLevel = ~~getParameterByName('courseLevel');
        const correctStatus = getParameterByName('correctStatus');
        const sectionName = getParameterByName('sectionName');
        const title = getParameterByName('title');
        const nickname = getParameterByName('nickname');
        const homeworkId = ~~getParameterByName('homeworkId');
        const lessonId = ~~getParameterByName('lessonId');
        const answerUrl = getParameterByName('answerUrl');
        const homeworkIdList = getParameterByName('homeworkIdList');
        
        // 从其他页面跳转来时，将 homeworkIdList 和 currentPageIndex 存入 sessionStorage
        if (homeworkIdList) {
            const list = JSON.parse(homeworkIdList);
            let homeworkIdIndex;
            list.forEach((value, key) => {
                if (value === homeworkId) {
                    homeworkIdIndex = key;
                }
            });

            setAssistantWorkInfo({
                homeworkIdList: list,
                currentPageIndex: homeworkIdIndex || 0
            });
        }

        if (getParameterByName('correctStatus') === 'DONE') {
            this.props.onSetHomeworkCorrected();
        }

        this.state = {
            className: className,
            courseLevel: courseLevel,
            correctStatus: correctStatus,
            sectionName: sectionName,
            title: title,
            homeworkTitle: `${className}-L${courseLevel}:${sectionName}-${title}-${nickname}`,
            homeworkId: homeworkId || 0,
            lessonId: lessonId || 0,
            answerUrl: answerUrl,
            answerTitle: `${className}-L${courseLevel}:${sectionName}-${title}-正确答案`,
            isAnswer: isAnswer,
            isListEmpty: false,
            showTips: false
        };
    }

    componentDidMount () {
        if (isLastHomework()) {
            this.setListEmptyState();
        }

        if (getParameterByName('showTips')) {
            this.setTipsState(true);
        }
    }

    setTipsState (state) {
        this.setState({
            showTips: state
        });
    }

    setListEmptyState () {
        this.setState({
            isListEmpty: true
        });
    }

    handleTimeoutHideTips () {
        this.setTipsState(false);
    }

    handleClickAnswer () {
        window.open(`http://${location.host}/?mode=assistant&isAnswer=isAnswer&url=${this.state.answerUrl}&className=${this.state.className}&courseLevel=${this.state.courseLevel}&sectionName=${this.state.sectionName}&title=${this.state.title}`);
    }

    handleClickNextItem () {
        goAeadToNextHomework();
    }

    /**
     * 当点击【点评/再次点评】按钮时，判断当前作业文件是否被更新：
     * 若被更新，则加载新的作业文件，并传入参数 showTips=true （当新作业打开时弹出提示）
     * 若未更新，则将状态更改为【点评中】，并打开点评模态框
     */
    handleClickOpenSubmitCommentModal () {
        const homeworkId = this.state.homeworkId;
        if (homeworkId) {
            const homeworkUrl = getParameterByName('url');
            const getList = getHomeworkInfo(homeworkId);
            
            getList.then(
                currentInfo => {
                    const info = currentInfo[0];

                    if (homeworkUrl === info.homeworkUrl) {
                        if (this.state.correctStatus === 'NONE') {
                            const correctStatus = 'DOING';
                            setHomeworkStatus(correctStatus, homeworkId, null, null);
                        }
                        this.props.onOpenSubmitCommentModal();
                    } else {
                        const tutor = getParameterByName('isTutor') === '1' ? `isTutor=1&` : '';
                        window.location.replace(`//${location.host}/?${tutor}mode=assistant&url=${info.homeworkUrl}&homeworkId=${info.homeworkId}&className=${info.className}&courseLevel=${info.courseLevel}&sectionName=${info.sectionName}&title=${info.title}&nickname=${info.nickname}&answerUrl=${info.answerUrl}&lessonId=${info.lessonId}&correctStatus=${info.correctStatus}&showTips=true`); //eslint-disable-line
                    }
                }
            );
        }
    }

    render () {
        return (
            <MenuBarAssistantComponent
                answerTitle={this.state.answerTitle}
                answerUrl={this.state.answerUrl}
                homeworkId={this.state.homeworkId}
                homeworkTitle={this.state.homeworkTitle}
                isAnswer={this.state.isAnswer}
                isListEmpty={this.state.isListEmpty}
                isTutor={this.props.isTutor}
                lessonId={this.state.lessonId}
                showTips={this.state.showTips}
                onClickAnswer={this.handleClickAnswer}
                onClickNextItem={this.handleClickNextItem}
                onHideTips={this.handleTimeoutHideTips}
                onOpenSubmitCommentModal={this.handleClickOpenSubmitCommentModal}
            />
        );
    }
}

MenuBarAssistant.propTypes = {
    isTutor: PropTypes.bool,
    onOpenSubmitCommentModal: PropTypes.func,
    onSetHomeworkCorrected: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
    onOpenSubmitCommentModal: () => dispatch(openSubmitCommentModal()),
    onSetHomeworkCorrected: () => dispatch(setHomeworkCorrected())
});

export default injectIntl(connect(
    null,
    mapDispatchToProps
)(MenuBarAssistant));
